import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { PaymentComponent } from './payment.component';
import { PaymentStatusComponent } from './payment-status/payment-status.component';

const routes: Routes = [
  { path: 'payment/:id', component: PaymentComponent, pathMatch: 'full' },
  {
    path: 'bookings/:id/paymentsuccess',
    component: PaymentSuccessComponent,
    pathMatch: 'full',
  },
  {
    path: 'payment-status/:id',
    component: PaymentStatusComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentRoutingModule {}
